module.exports = __webpack_public_path__ + "img/Group3@2x(2).0344dba2.png";